export const env = {
  STORYBLOK_TOKEN: '0mgISTsALrn23nchwjr3rgtt',
  BASE_URL: 'https://easypeasy.com.ua',
  GOOGLE_TAG_MANAGER_ID: 'GTM-TFTSNHQ',
  FACEBOOK_PIXEL_ID: '456298908691037',
  ANDROID_PACKAGE_NAME: 'ua.com.easypeasy.tracker',
  IOS_BUNDLE_ID: 'ua.com.easypeasy.tracker',
};
